import { createCompoundComponent } from '../../utilities'
import { Tabs as BaseTabs } from './Tabs'
import { Header } from './Header'
import { Panel } from './Panel'
import { Panels } from './Panels'
import { Tab } from './Tab'

export const Tabs = createCompoundComponent(BaseTabs, {
  Header,
  Panel,
  Panels,
  Tab,
})
